export const NAV_LINKS = [
  { label: 'Services', href: '#services' },
  { label: 'Why Us', href: '#why' },
  { label: 'Process', href: '#process' },
  { label: 'Clients', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

export const SERVICES = [
  {
    icon: '☁️',
    title: 'Cloud Solutions',
    desc: 'Migrate, optimize, and scale your infrastructure on AWS, Azure, or GCP. We handle architecture, cost optimization, and 24/7 monitoring so your systems run flawlessly.',
    tag: 'AWS · Azure · GCP',
    color: '#00e5ff',
  },
  {
    icon: '🛡️',
    title: 'Cybersecurity',
    desc: 'Enterprise-grade security audits, penetration testing, compliance management, and real-time threat detection to protect your most valuable digital assets.',
    tag: 'ISO 27001 · SOC2',
    color: '#ff5c8a',
  },
  {
    icon: '⚡',
    title: 'Custom Software Dev',
    desc: 'Bespoke web and mobile applications engineered for performance, designed for users, and built to evolve seamlessly alongside your business objectives.',
    tag: 'React · Node · Flutter',
    color: '#7c3aed',
  },
  {
    icon: '🔄',
    title: 'DevOps & Automation',
    desc: 'Accelerate delivery with CI/CD pipelines, infrastructure-as-code, containerization, and intelligent deployment strategies that cut release cycles in half.',
    tag: 'Docker · K8s · Terraform',
    color: '#00e5ff',
  },
  {
    icon: '🤖',
    title: 'AI & Data Analytics',
    desc: 'Unlock actionable insights with machine learning models, predictive analytics, natural language processing, and BI dashboards tailored to your data.',
    tag: 'Python · TensorFlow · PowerBI',
    color: '#ff5c8a',
  },
  {
    icon: '🎯',
    title: 'IT Consulting',
    desc: 'Strategic technology roadmaps, digital transformation planning, vendor selection, and CTO-as-a-service for organizations at any stage of growth.',
    tag: 'Strategy · Roadmapping',
    color: '#7c3aed',
  },
];

export const STATS = [
  { num: '250', suffix: '+', label: 'Projects Delivered' },
  { num: '98', suffix: '%', label: 'Client Satisfaction' },
  { num: '12', suffix: 'yr', label: 'Industry Experience' },
  { num: '40', suffix: '+', label: 'Expert Engineers' },
];

export const WHY_POINTS = [
  {
    num: '01',
    title: 'Full-Stack Expertise',
    desc: 'Our certified engineers cover infrastructure, backend, frontend, and AI — eliminating the chaos of managing multiple vendors for a single project.',
  },
  {
    num: '02',
    title: 'Agile Delivery, Guaranteed',
    desc: 'Two-week sprint cycles, transparent milestones, and a dedicated project manager keep you in control at every stage of development.',
  },
  {
    num: '03',
    title: 'Security-First Philosophy',
    desc: 'Security is architected into every solution from day one — covering compliance frameworks, encryption standards, and granular access controls.',
  },
  {
    num: '04',
    title: '24/7 Support & Monitoring',
    desc: 'Round-the-clock monitoring, sub-5-minute incident response, and a dedicated support team ensure your systems never sleep unguarded.',
  },
];

export const PROCESS_STEPS = [
  {
    num: '01',
    title: 'Discovery',
    desc: 'Deep-dive into your goals, constraints, and tech landscape to define the right solution strategy.',
    icon: '🔍',
  },
  {
    num: '02',
    title: 'Architecture',
    desc: 'System design, tech stack selection, and a detailed project roadmap with measurable milestones.',
    icon: '🏗️',
  },
  {
    num: '03',
    title: 'Build & Test',
    desc: 'Agile development with continuous QA, code reviews, and stakeholder demos every sprint cycle.',
    icon: '⚙️',
  },
  {
    num: '04',
    title: 'Launch & Scale',
    desc: 'Zero-downtime deployment, performance tuning, and ongoing optimization long after go-live.',
    icon: '🚀',
  },
];

export const TESTIMONIALS = [
  {
    stars: 5,
    quote:
      'CreatixHub reduced our cloud infrastructure costs by 42% while improving performance metrics across the board. Their team genuinely cares about outcomes, not just deliverables.',
    name: 'Arjun Kapoor',
    role: 'CTO, FinEdge Solutions',
    initials: 'AK',
    gradient: 'linear-gradient(135deg, #00e5ff, #005f6b)',
  },
  {
    stars: 5,
    quote:
      'From zero to production in just 8 weeks. The custom platform handles 100K+ concurrent users flawlessly. The most professional development team we have ever worked with.',
    name: 'Sara Mehta',
    role: 'CEO, SwiftCommerce',
    initials: 'SM',
    gradient: 'linear-gradient(135deg, #7c3aed, #4c1d95)',
  },
  {
    stars: 5,
    quote:
      'Their cybersecurity audit uncovered critical vulnerabilities we had missed for years. Post-remediation, we passed ISO 27001 certification on our very first attempt.',
    name: 'Rahul Nair',
    role: 'Head of IT, MediCore Group',
    initials: 'RN',
    gradient: 'linear-gradient(135deg, #ff5c8a, #831843)',
  },
];

export const MARQUEE_ITEMS = [
  '☁️ Cloud Infrastructure',
  '🛡️ Cybersecurity',
  '⚙️ DevOps & CI/CD',
  '📱 Mobile Development',
  '🤖 AI & Machine Learning',
  '🔗 API Integrations',
  '🏗️ Software Architecture',
  '📊 Data Analytics',
  '🔐 Identity & Access',
  '📦 Microservices',
];

export const FOOTER_LINKS = {
  Services: ['Cloud Solutions', 'Cybersecurity', 'Custom Development', 'DevOps', 'AI & Analytics', 'IT Consulting'],
  Company: ['About Us', 'Case Studies', 'Careers', 'Blog', 'Partners'],
  Contact: ['creatixhub21@gmail.com', '8269485230', 'indore madhya pradesh', 'Support Portal'],
};
